var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 11.2733V18.0001C23.1426 18.2275 23.0523 18.4455 22.8916 18.6062C22.7309 18.767 22.5128 18.8573 22.2855 18.8573H1.71408C1.48675 18.8573 1.26873 18.767 1.10798 18.6062C0.947239 18.4455 0.856934 18.2275 0.856934 18.0001V4.28585C0.856934 4.05853 0.947239 3.84051 1.10798 3.67976C1.26873 3.51902 1.48675 3.42871 1.71408 3.42871H12.2844",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2856 18.8574L8.57129 23.1431",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7139 18.8574L15.4282 23.1431",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85693 23.1436H17.1426",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2856 3.42885C16.2856 2.92027 16.4365 2.42311 16.719 2.00024C17.0016 1.57737 17.4032 1.24779 17.873 1.05316C18.3429 0.858536 18.8599 0.807613 19.3587 0.906832C19.8575 1.00605 20.3157 1.25096 20.6753 1.61058C21.035 1.9702 21.2799 2.42838 21.3791 2.92719C21.4783 3.426 21.4274 3.94303 21.2328 4.41289C21.0381 4.88276 20.7086 5.28436 20.2857 5.56692C19.8628 5.84947 19.3657 6.00028 18.8571 6.00028V7.71457",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8568 12.0007C18.7431 12.0007 18.6341 11.9555 18.5537 11.8752C18.4734 11.7948 18.4282 11.6858 18.4282 11.5721C18.4282 11.4585 18.4734 11.3495 18.5537 11.2691C18.6341 11.1887 18.7431 11.1436 18.8568 11.1436",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8569 12.0007C18.9706 12.0007 19.0796 11.9555 19.16 11.8752C19.2404 11.7948 19.2855 11.6858 19.2855 11.5721C19.2855 11.4585 19.2404 11.3495 19.16 11.2691C19.0796 11.1887 18.9706 11.1436 18.8569 11.1436",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIcon);
export default __webpack_public_path__ + "static/media/quiz-icon.110d1e76183b0ef437b8cfecde395677.svg";
export { ForwardRef as ReactComponent };